/**
 * Toast notification types and enums
 */

export enum ToastType {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export enum ToastPosition {
  TopRight = 'top-right',
  TopLeft = 'top-left',
  BottomRight = 'bottom-right',
  BottomLeft = 'bottom-left',
}

export type ToastNotify = {
  id: string;
  message: string;
  type: ToastType;
  position: ToastPosition;
  duration: number;
};
